import {ActionCost, Cost} from "../../services/RealmServiceContext";

export function combineCosts(actionCosts: ActionCost[]): Cost[] {
    const finalActionCost = new ActionCost(1,[]);
    actionCosts.forEach(a => finalActionCost.combine(a.combinedCosts));
    return finalActionCost.asCostList();
}